import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import CustomRoutes from './components/CustomRoutes';
import useAutoSignIn from './hooks/useCurrentUser';
import GlobalDateContext from './globalDateContext';
import { permissions } from './constants';

const Login = lazy(() => import('./pages/Login/Login'));
const AuthRedirect = lazy(() => import('./pages/AuthRedirect/AuthRedirect'));
const Charts = lazy(() => import('./pages/Charts'));

export default function App() {
  useAutoSignIn();
  return (
    <GlobalDateContext>
      <Switch>
        <CustomRoutes.AccessibleBeforeAuth exact path="/" component={Login} />
        <CustomRoutes.AccessibleBeforeAuth exact path="/auth-callback" component={AuthRedirect} />
        <CustomRoutes.AccessibleAfterAuth exact path="/home" render={() => <Charts id="home-page-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/requests-count" render={() => <Charts id="requests-count-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/requests-status" render={() => <Charts id="requests-status-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/users" render={() => <Charts id="users-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact permissions={[permissions.ANALYTICS_DASHBOARD_USER]} path="/payments" render={() => <Charts id="payments-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/emergency-stats" render={() => <Charts id="emergency-app-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/performance-stats" render={() => <Charts id="performance-indicators-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/platform-response" render={() => <Charts id="platform-response-indicators" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/CID-stats" render={() => <Charts id="cid-stats" />} />
        <CustomRoutes.AccessibleAfterAuth exact path="/rating" render={() => <Charts id="rating-stats" />} />

      </Switch>
    </GlobalDateContext>
  );
}
